import React, { CSSProperties } from 'react'
import { connect } from 'react-redux'
import { Grid, Segment } from 'semantic-ui-react'
import { LKDate } from 'loankeeper-common/helpers/Date'
//@ts-ignore
import LKButton from 'shared/LKButton'
//@ts-ignore
import LKGrid from 'shared/LKGrid'
//@ts-ignore
import { SegmentGroup, GridContainer } from 'shared/StyledComponents'
import { withLivedata, withConstantPermissions } from 'shared'
import { deleteMonitoring } from '../../../store/loan'
import translate, { translateLKMessage } from '../translator'
import { constants as DCConstants, actions as DCActions } from '../../DetailsContainer'
import LoanMonitoringForm, { open } from '../../LoanMonitoringForm'

import { MonitoringProps } from '../types.LoanDetails'

const style: {
  [key: string]: CSSProperties
} = {
  parent: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    padding: '14px',
    width: '100%',
    overflowY: 'auto',
  },

  second: {
    flex: 1,
    position: 'relative',
    overflow: 'auto',
  },
}

const LKGridConfig = {
  gridIdentity: {
    formName: 'frm_loan_view',
    objectName: 'dbgrd_mon',
  },

  columnDefs: [
    { headerName: 'SDate', field: 'SDate' },
    { headerName: 'Title', field: 'Title' },
    { headerName: 'FullName', field: 'SEC_UserID' },
    { headerName: 'Comment', field: 'Comment' },
  ],

  syncGridState: true,
  enableColumnsResize: true,
  enableColumnsOrder: true,
  enableRowSelection: true,

  columnConfigs: {
    SDate: {
      valueFormatter: ({ value }) => LKDate.from(value).toString(),
    },
  },
}

//@ts-ignore
@connect(undefined, {
  open,
  fetchPage: (ID, hash) =>
    DCActions.fetchPage({
      type: 'Loan',
      ID,
      hash,
      page: 'monitoring',
    }),
  deleteMonitoring,
})
//@ts-ignore
@withLivedata('OpenDayStatus.Open_Day_Str as openDayStr')
//@ts-ignore
@withConstantPermissions([
  'ALTER_LOAN_MONITORING_CLOSEDAY as CanAlterMonitoringCloseDay',
  'EDIT_LOAN_MONITORING as CanEditLoanMonitoring',
])
class Monitoring extends React.Component<MonitoringProps> {
  getContextMenuItems = ({ node: { data } }) =>
    this.props.data.base.IsArrested !== 1
      ? [
          this.props.CanAlterMonitoringCloseDay ||
          (this.props.CanEditLoanMonitoring &&
            LKDate.from(this.props.openDayStr).instance.isSame(LKDate.from(data.SDate).instance, 'day'))
            ? {
                name: translate('cmd_mon_edit'),
                icon: 'edit',
                action: () => this.props.open({ data }),
                permissionKey: 'EDIT_LOAN_MONITORING',
              }
            : undefined,

          {
            name: translate('cmd_mon_delete'),
            icon: 'delete',
            action: () =>
              this.props
                .deleteMonitoring({
                  ID: data.ID,
                  LoanID: this.props.ID,
                  HashSum_LoanID_: this.props.hash,
                  HashSum_LoanMonID_: data.HashSum_LoanMonID_,
                })
                .then(() => this.props.fetchPage(this.props.ID, this.props.hash)),
            confirmModalConfig: { message: translateLKMessage('CONFIRM_MONITORING_DELETE') },
            permissionKey: 'DELETE_LOAN_MONITORING',
          },
        ].filter((x) => x !== undefined)
      : []

  handleAdd = () => this.props.open()

  render() {
    const {
      ID,
      hash,
      data: { monitoring, base, linkedfiles },
    } = this.props

    return (
      <SegmentGroup>
        <Segment.Group>
          <div style={style.second}>
            <LKGrid
              instanceName={`${DCConstants.DetailsGridPrefixes.loan}-${ID}-Monitoring`}
              rowData={monitoring}
              {...LKGridConfig}
              getContextMenuItems={this.getContextMenuItems}
            />
          </div>
          <LoanMonitoringForm LoanID={ID} LoanHash={hash} linkedfiles={linkedfiles} />

          {base.IsArrested !== 1 && (
            <Segment>
              <GridContainer>
                <Grid>
                  <Grid.Row>
                    <Grid.Column>
                      <LKButton alias="add" onClick={this.handleAdd} permission="ADD_LOAN_MONITORING">
                        {translate('cmd_mon_add')}
                      </LKButton>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </GridContainer>
            </Segment>
          )}
        </Segment.Group>
      </SegmentGroup>
    )
  }
}

export default Monitoring
